import { BasePoolConfig, PoolInfo } from "../types";

export const arbitrumInfo: Record<string, PoolInfo> = {
  // pt-usde-usdc
  "0x79C37E226834Dc6BfB04Ba0b60f823515c32f50D": {
    maturityDate: "2024-08-29T00:00:00.000+00:00", // 1724889600 // https://arbiscan.io/address/0xad853EB4fB3Fe4a66CdFCD7b75922a0494955292#readContract#F8
    sparksPerQuotePerDay: 0.033,
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
    finished: true,
  },

  // knox-eusd
  "0x3125e87D2630eb7DADD7F94e2fE05Bd21eE10C4f": {
    sparksPerQuotePerDay: 0.033,
    isFarm: true,
    chainId: 42161,
    flip: true,
    protocol: "Reserve",
  },
  // usde-usdc
  "0x9007A45304Ac6676CEf22ec68c870ae88Af60065": {
    sparksPerQuotePerDay: 0.033,
    chainId: 42161,
    flip: true,
  },
  // ethplus-weth
  "0xb1Af7B299ABBE4905Bbc80E614f64caCFEfBc96b": {
    sparksPerQuotePerDay: 100,
    isFarm: true,
    chainId: 42161,
    unwrap: "quote",
    flip: true,
    protocol: "Reserve",
  },
  // pt-ezeth-26sep2024-ezeth
  "0x44579419E975f4d59eaA0876f2EdCA7F2531821A": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
    protocol: "Renzo",
    finished: true,
  },
  // pt-weeth-26sep2024-weeth
  "0x3ad4F88aF401bf5F4F2fE35718139cacC82410d7": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    bonus: ["etherFi", "eigenLayer", "turtleDao"],
    chainId: 42161,
    flip: true,
    protocol: "Ether.fi",
    finished: true,
  },
  // pt-rseth-26dec2024-rseth
  "0x5ecE952A12b87f909b4Bd8137DD30fd07b80c2C4": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
    protocol: "Kelp",
  },
  // pt-unieth-26dec2024-unieth
  "0x1be9c0343F6A5E3F1E8c76e6cEF05EEbda4074D3": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
    protocol: "Bedrock",
  },
  // pt-weeth-26dec2024-weeth
  "0x2E70CC46F465ab249D6972cCeb0363a6B07AeA01": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-12-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
    protocol: "Ether.fi",
    bonus: ["etherFi", "eigenLayer"],
  },

  // PT-rsETH-26SEP2024-rsETH
  "0x6128F06bF224F8407d5cBD7476D2BE0848aA05aF": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-09-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
    bonus: ["kelp", "eigenLayer"],
    protocol: "Kelp",
    finished: true,
  },

  // PT-weETH-27JUN2024-WETH
  "0xcf848A30153506617B07207D2B3d054D4Fb72EBC": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2024-06-27T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
    finished: true,
  },

  // pt-wsteth-26jun2025-weth
  "0x856e0317130F468d2bcd104b42B82337300765b0": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2025-06-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
  },

  // pt-reth-26jun2025-weth
  "0xC8C1CdD42D02eaF4F775eaF9f4b4a37a5272118d": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2025-06-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
  },

  // pt-weeth-26jun2025-weth
  "0xe302CA50234D336A8Cff0AD11Af1Aa00C0F174e2": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2025-06-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
  },

  // pt-rseth-26jun2025-weth
  "0x727B79bFd88600fa425619280bc24A0B60Cf14DA": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2025-06-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
  },

  // pt-unieth-26jun2025-weth
  "0x8A048FdC480ADEc0C7A77277F398709AEa7e4461": {
    sparksPerQuotePerDay: 200,
    maturityDate: "2025-06-26T00:00:00.000+00:00",
    isPendle: true,
    isFarm: true,
    chainId: 42161,
    flip: true,
  },

  // weth-usdc
  "0x87e711BcB9Ed1f2f6dec8fcC74cD2e0613D43b86": {
    chainId: 42161,
    unwrap: "base",
  },
  // arb-usdc
  "0x0F750fBb044037254b5843C6b4a715AA12876d94": {
    chainId: 42161,
  },
  // weth-usdc.e
  "0x53C08A5e2b7bc973d3d5Aee60373969E30e93B93": {
    chainId: 42161,
    unwrap: "base",
  },
  // arb-usdc.e
  "0x5ceB22fe09C7259b9dceef243615f180664BCE70": {
    chainId: 42161,
  },
  // wbtc-weth
  "0x99Cc2A68e121F2434db5C5D63670212F07f89ee8": {
    chainId: 42161,
    unwrap: "quote",
  },
  // gmx-weth
  "0x0637B18b5c5b7fe72F63a5511D2e90BEc7FC828E": {
    chainId: 42161,
    unwrap: "quote",
  },
  // pendle-weth
  "0x3adc0f25c7A23a626A67811c47d0A0DbE21773a4": {
    chainId: 42161,
    unwrap: "quote",
  },
  // rdnt-weth
  "0x82bC6A8dA5988E66676014cA99056Bd7A2f44dF2": {
    chainId: 42161,
    unwrap: "quote",
  },
};
export const arbitrumPools: BasePoolConfig[] = [
  // pt-usde-usdc
  {
    address: "0x79C37E226834Dc6BfB04Ba0b60f823515c32f50D",
    uniswapAddress: "0x2dfaf9a5e4f293bceede49f2dba29aacdd88e0c4", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/arbitrum-v1.5-pendle/config.json#L93C28-L93C70
  },
  // pt-ezeth-26sep2024-ezeth
  {
    address: "0x44579419E975f4d59eaA0876f2EdCA7F2531821A",
    uniswapAddress: "0x35f3db08a6e9cb4391348b0b404f493e7ae264c0", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L102
  },
  // pt-weeth-26sep2024-weeth
  {
    address: "0x3ad4F88aF401bf5F4F2fE35718139cacC82410d7",
    uniswapAddress: "0xf9f9779d8ff604732eba9ad345e6a27ef5c2a9d6", // https://github.com/eq-lab/marginly/blob/c04aa1a816415fa599d8d1a37d268cbdb51f49c4/packages/deploy/src/data/deploy/ethereum-v1.5-pendle/config.json#L102
  },
  // weth-usdc
  {
    address: "0x87e711BcB9Ed1f2f6dec8fcC74cD2e0613D43b86",
    uniswapAddress: "0xC6962004f452bE9203591991D15f6b388e09E8D0",
  },
  // arb-usdc
  {
    address: "0x0F750fBb044037254b5843C6b4a715AA12876d94",
    uniswapAddress: "0xb0f6cA40411360c03d41C5fFc5F179b8403CdcF8",
  },
  // weth-usdc.e
  {
    address: "0x53C08A5e2b7bc973d3d5Aee60373969E30e93B93",
    uniswapAddress: "0xC31E54c7a869B9FcBEcc14363CF510d1c41fa443",
  },
  // arb-usdc.e
  {
    address: "0x5ceB22fe09C7259b9dceef243615f180664BCE70",
    uniswapAddress: "0xcDa53B1F66614552F834cEeF361A8D12a0B8DaD8",
  },
  // wbtc-weth
  {
    address: "0x99Cc2A68e121F2434db5C5D63670212F07f89ee8",
    uniswapAddress: "0x2f5e87C9312fa29aed5c179E456625D79015299c",
  },
  // gmx-weth
  {
    address: "0x0637B18b5c5b7fe72F63a5511D2e90BEc7FC828E",
    uniswapAddress: "0x1aEEdD3727A6431b8F070C0aFaA81Cc74f273882",
  },
  // pendle-weth
  {
    address: "0x3adc0f25c7A23a626A67811c47d0A0DbE21773a4",
    uniswapAddress: "0xdbaeB7f0DFe3a0AAFD798CCECB5b22E708f7852c",
  },
  // rdnt-weth
  {
    address: "0x82bC6A8dA5988E66676014cA99056Bd7A2f44dF2",
    uniswapAddress: "0x446BF9748B4eA044dd759d9B9311C70491dF8F29",
  },
  //knox-eusd
  {
    address: "0x3125e87D2630eb7DADD7F94e2fE05Bd21eE10C4f",
    uniswapAddress: "0x6f33daf91d2acae10f5cd7bbe3f31716ed123f1d",
  },
  //ethplus-weth
  {
    address: "0xb1Af7B299ABBE4905Bbc80E614f64caCFEfBc96b",
    uniswapAddress: "0x95f425c7d730eb7673fca272c2c305f48ed546c3",
  },
  //usde-usdc
  {
    address: "0x9007A45304Ac6676CEf22ec68c870ae88Af60065",
    uniswapAddress: "0xc23f308CF1bFA7efFFB592920a619F00990F8D74",
  },
  // PT-rsETH-26SEP2024-rsETH
  {
    address: "0x6128F06bF224F8407d5cBD7476D2BE0848aA05aF",
    uniswapAddress: "0xed99fc8bdb8e9e7b8240f62f69609a125a0fbf14",
  },
  // pt-rseth-26dec2024-rseth
  {
    address: "0x5ecE952A12b87f909b4Bd8137DD30fd07b80c2C4",
    uniswapAddress: "0xcb471665bf23b2ac6196d84d947490fd5571215f",
  },
  // pt-unieth-26dec2024-unieth
  {
    address: "0x1be9c0343F6A5E3F1E8c76e6cEF05EEbda4074D3",
    uniswapAddress: "0x279b44e48226d40ec389129061cb0b56c5c09e46",
  },
  // pt-weeth-26dec2024-weeth
  {
    address: "0x2E70CC46F465ab249D6972cCeb0363a6B07AeA01",
    uniswapAddress: "0x6b92feb89ed16aa971b096e247fe234db4aaa262",
  },
  // PT-weETH-27JUN2024-WETH
  {
    address: "0xcf848A30153506617B07207D2B3d054D4Fb72EBC",
    uniswapAddress: "0x952083cde7aaa11ab8449057f7de23a970aa8472",
  },
  {
    // PT-USDe-28NOV2024
    address: "0x760B9fE6b1f6c5dD7597A02690ffe3F6a07a3042",
    uniswapAddress: "0x281fe15fd3e08a282f52d5cf09a4d13c3709e66d", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/arbitrum-v1.5-pendle/config.json#L189C28-L189C70
  },
  {
    // PT-gUSDC-26DEC2024
    address: "0x230A545aBE3217BA3BdA3EEec2D8582dFD4B73CE",
    uniswapAddress: "0xa877a0e177b54a37066c1786f91a1dab68f094af", // https://github.com/eq-lab/marginly/blob/b27d2b2760fbdbd365360d98e68b507268ce9097/packages/deploy/src/data/deploy/arbitrum-v1.5-pendle/config.json#L180
  },
  {
    // pt-wsteth-26jun2025-weth
    address: "0x856e0317130F468d2bcd104b42B82337300765b0",
    uniswapAddress: "0x08a152834de126d2ef83d612ff36e4523fd0017f",
  },

  {
    // pt-reth-26jun2025-weth
    address: "0xC8C1CdD42D02eaF4F775eaF9f4b4a37a5272118d",
    uniswapAddress: "0x14fbc760efaf36781cb0eb3cb255ad976117b9bd",
  },
  {
    // pt-weeth-26jun2025-weth
    address: "0xe302CA50234D336A8Cff0AD11Af1Aa00C0F174e2",
    uniswapAddress: "0xbf5e60ddf654085f80dae9dd33ec0e345773e1f8",
  },
  {
    // pt-rseth-26jun2025-weth
    address: "0x727B79bFd88600fa425619280bc24A0B60Cf14DA",
    uniswapAddress: "0x816f59ffa2239fd7106f94eabdc0a9547a892f2f",
  },
  {
    // pt-unieth-26jun2025-weth
    address: "0x8A048FdC480ADEc0C7A77277F398709AEa7e4461",
    uniswapAddress: "0x3e4e3291ed667fb4dee680d19e5702ef8275493d",
  },
];
